class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
    this.resultsBox = this.querySelector('.header__search-results');
    this.resultsTemplate = '';
    this.input = this.querySelector('[name="q"]');
    this.debouncedFetchResults = debounce(this.fetchResults.bind(this), 500);
    this.abortController = null;

    if (this.input) {
      this.input.addEventListener('input', this.search.bind(this));
      this.input.addEventListener('focus', this.search.bind(this));
    }

    this.addEventListener('click', evt => {
      if (evt.target.closest('.header__search-tabs-caption li:not(.active)')) {
        const activeCaption = document.querySelector('.header__search-tabs-caption li.active');
        const activeTabContent = document.querySelector('.header__search-tabs-content.active');
        const selectTabContent = document.querySelector(`#${evt.target.dataset.tab}`);
        activeCaption.classList.remove('active');
        activeTabContent.classList.remove('active');
        evt.target.classList.add('active');
        selectTabContent.classList.add('active');
      }
    });
    this.addEventListener('click', evt => {
      if (evt.target.closest('.header__search-overlay')) {
        this.hideResults();
      }
    });
  }

  search(evt) {
    const target = evt.target;
    const term = target.value;

    if (term.length < 2) {
      this.hideResults();
      return false;
    }

    this.debouncedFetchResults(term);
  }

  fetchResults(term) {
    if (this.abortController) {
      this.abortController.abort();
    }

    this.abortController = new AbortController();

    const queries = [
      `*${term}*`,
      `title:*${term}*`,
      `sku:*${term}*`,
      `product_type:*${term}*`,
      `tag:*${term}*`
    ].join(' OR ');

    fetch(`/search?view=json&q=${encodeURIComponent(queries)}`, {
      signal: this.abortController.signal
    })
      .then(response => response.json())
      .then(suggestions => {
        const productSuggestions = suggestions.resources.results.products || [];
        const articleSuggestions = suggestions.resources.results.articles || [];
        let productsTemplate = '';
        let articlesTemplate = '';

        if (productSuggestions.length > 0) {
          productSuggestions
            .filter(product => product.available)
            .forEach(product => {
              productsTemplate += this.createItemTemplate({
                url: `${Shopify.routes.root}products/${product.handle}`,
                image: product.featured_image,
                title: product.title,
                priceMax: product.price_max,
                priceMin: product.price_min,
              });
            });
        }

        if (articleSuggestions.length > 0) {
          articleSuggestions.forEach(article => {
            articlesTemplate += this.createItemTemplate({
              url: `${Shopify.routes.root}blogs/news/${article.handle}`,
              image: article.image.src,
              title: article.title,
              author: article.author,
            });
          });
        }

        if (productSuggestions.length === 0 && articleSuggestions.length === 0) {
          this.resultsTemplate = `
                          <div class="header__search-overlay"></div>
                          <div class="header__search-inner">
                              <div class="header__search-empty">Nothing found</div>
                          </div>
                      `;
        } else {
          this.resultsTemplate = `
                          <div class="header__search-overlay"></div>
                          <div class="header__search-inner">
                              <div class="header__search-tabs">
                                  <ul class="header__search-tabs-caption list-unstyled">
                                    <li class="active" data-tab="tab-products">Products (${productSuggestions.length})</li>
                                    <li data-tab="tab-articles">Articles (${articleSuggestions.length})</li>
                                  </ul>
                      
                                  <div id="tab-products" class="header__search-tabs-content header__search-product-item-list active">
                                      ${productsTemplate ? productsTemplate : '<div class="header__search-empty">Nothing found</div>'}
                                  </div>
                      
                                  <div id="tab-articles" class="header__search-tabs-content header__search-product-item-list">
                                      ${articlesTemplate ? articlesTemplate : '<div class="header__search-empty">Nothing found</div>'}
                                  </div>
                              </div>
                          </div>
                      `;
        }

        this.showResults();
      })
      .catch(e => {
        if (e.name !== 'AbortError') {
          console.error(e);
        }
      });
  }

  createItemTemplate({ url, image, title, priceMax, priceMin, author = '' }) {
    priceMax = priceMax && priceMax > priceMin ? ' - ' + formatMoney(priceMax) : '';
    priceMin = priceMin ? formatMoney(priceMin) : '';

    return `
        <div class="header__search-item">
            <a href="${url}" class="header__search-item__img">
                <img src="${image}" alt="">
            </a>
            <div class="header__search-item__desc">
                <a href="${url}" class="header__search-item__ttl">${title}</a>
                ${author ? `<div class="header__search-item__author">${author}</div>` : ''}
            </div>
        </div>
    `;
  }

  showResults() {
    this.resultsBox.classList.remove('hidden');
    this.resultsBox.innerHTML = this.resultsTemplate;
    if (!isIOS) {
      disableBodyScroll(this.resultsBox);
    }
  }

  hideResults() {
    this.resultsBox.classList.add('hidden');
    this.resultsBox.innerHTML = '';

    if (typeof enableBodyScroll === 'function') {
      enableBodyScroll(this.resultsBox);
    }
  }
}

customElements.define('predictive-search', PredictiveSearch);
